import { actionCreator } from '@ardoq/rxbeach';
import { ChartWindowState } from '@ardoq/graph';
import { Point } from '@ardoq/math';
import { HighlightState, QuadrantZoomState } from './types';

export const setCenter = actionCreator<Point>('[Bubble Chart] SET_CENTER');
export const setScale = actionCreator<ChartWindowState>(
  '[Bubble Chart] SET_SCALE'
);
export const panSettle = actionCreator('[Bubble Chart] PAN_SETTLE');

export const setHoverState = actionCreator<HighlightState>(
  '[Bubble Chart] SET_HOVER_STATE'
);
export const setFocusState = actionCreator<HighlightState>(
  '[Bubble Chart] SET_FOCUS_STATE'
);

export const setSelectedQuadrant = actionCreator<
  Pick<QuadrantZoomState, 'selectedQuadrant'>
>('[Bubble Chart] SET_QUADRANT_ZOOM_STATE');
